import { Section } from '@/components/investors/shared';
import { Sidebar } from '@/components/investors/Sidebar';
import { Subscription } from '@/components/investors/Subscription';
import { useInvestorPageTracking } from '@/components/investors/useInvestorPageTracking';
import Layout from '@/components/shared/Layout';
import { SEO, SeoProps } from '@/components/shared/SEO';
import { usEnConfig as config } from '@/pageConfig/investors';
import ogImage from '@/static/assets/home/og.png';
import { Flex } from '@lemonade-hq/cdk';
import React, { useMemo } from 'react';
import styled from 'styled-components';

const Container = styled(Flex)`
  position: relative;
  flex-direction: row;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  gap: 80px;
`;

const MainWrapper = styled(Section)`
  width: 100%;
  align-items: flex-start;
`;

interface InvestorsPageTemplateProps {
  seo: SeoProps;
}

const SEO_DESCRIPTION =
  "Visit Lemonade's Investor Relations site to access the latest news, events, stock information, financial reports, and governance details. Stay informed with our comprehensive resources, including annual reports, SEC filings, and updates on executive management and board of directors. Explore our innovative approach to insurance, powered by artificial intelligence and committed to social impact. Connect with us for investor FAQs, email alerts, and contact information. Discover more about Lemonade, a leader in renters, homeowners, car, pet, and life insurance.";

export const InvestorsPageTemplate: React.FC<React.PropsWithChildren<InvestorsPageTemplateProps>> = ({
  children,
  seo,
}) => {
  const memoizedSeo = useMemo(() => {
    return {
      ...seo,
      description: seo.description.length > 0 ? seo.description : SEO_DESCRIPTION,
    };
  }, [seo]);
  useInvestorPageTracking();
  return (
    <Layout {...config.layout} pb={[30, 0]} overflow="undefined" fixedHeader>
      <SEO {...memoizedSeo} ogImage={ogImage.src} />
      <Container alignItems="flex-start" pt={[110, 80, 20]} pb={[40, 70]}>
        <Sidebar />
        <MainWrapper>{children}</MainWrapper>
      </Container>
      <Subscription
        title="Subscribe to Lemonade Updates"
        content="Sign up for the latest news, delivered to your inbox"
        email="ir@lemonade.com"
      />
    </Layout>
  );
};
